/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripDetailsInformation: "trip-block-information",
  tripDetailsAssignment: "trip-block-assignment",
  tripDetailsEvents: "trip-block-events",
  tripDetailsOverview: "trip-details-overview",
  tripDetailsPayments: "trip-details-payments",
  tripDetailsDeleteTrip: "trip-details-delete-trip",
  tripDetailsRouteMap: "trip-details-route-map",
  tripDetailsChangeOrder: "trip-details-change-order",
  tripDetailsChangeAssignment: "trip-details-change-assignment",
  tripDetailsDownloadRateConfirmation: "trip-details-download-rate-confirmation",
  tripDetailsSendRateConfirmation: "trip-details-send-rate-confirmation",
  tripDetailsCancel: "trip-details-cancel",
  tripDetailsSend: "trip-details-send",
} as const;
